var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ActionsMenu',[(_vm.userIsAuthor())?_c('PostEdit',{attrs:{"post":_vm.post}}):_vm._e(),(_vm.userIsAuthor())?_c('PostDelete',{attrs:{"post":_vm.post}}):_vm._e(),(_vm.communityIsPublic())?_c('PostShare',{attrs:{"post":_vm.post}}):_vm._e(),_c('PostReport',{attrs:{"post":_vm.post}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }